import { FLOORS_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";
import { IPagination } from "../../shared/interfaces/shared/IPagination";
import { IFloor } from "../../shared/interfaces/floor/IFloor";

export const FloorService = {
  getAll: (params: IPagination) => requests.get(`${FLOORS_URL}`, params),
  create: (params: IFloor) => requests.post(`${FLOORS_URL}`, params),
  getSingle: (id: number) => requests.get(`${FLOORS_URL}/${id}`),
  update: (params: IFloor, id: number) =>
    requests.put(`${FLOORS_URL}/${id}`, params),
  delete: (id: number) => requests.delete(`${FLOORS_URL}/${id}`),
  sort: (ids: number[]) => requests.patch(`${FLOORS_URL}/sort`, { ids }),
};
